var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1280",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "띠배너 관리"
    },
    scopedSlots: _vm._u([{
      key: "add-button",
      fn: function () {
        return [_c('band-banner-form', {
          on: {
            "input": _vm.updateItem
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var attrs = _ref.attrs,
                on = _ref.on;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "my-n2",
                attrs: {
                  "small": "",
                  "fab": "",
                  "tile": "",
                  "color": "transparent primary--text"
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
            }
          }])
        })];
      },
      proxy: true
    }])
  }), _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref2) {
          var value = _ref2.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.href`,
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('v-row', {
          attrs: {
            "align": "center",
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "text-truncate"
        }, [_vm._v(" " + _vm._s(value || "-") + " ")]), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "icon": "",
            "href": value,
            "target": "_blank",
            "disabled": !value
          }
        }, [_c('v-icon', [_vm._v(" mdi-link ")])], 1)], 1)], 1)];
      }
    }, {
      key: `item.imagePc`,
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('image-popup', _vm._b({
          attrs: {
            "src": value === null || value === void 0 ? void 0 : value.url
          }
        }, 'image-popup', {
          attrs_avatar: _vm.attrs_avatar
        }, false))];
      }
    }, {
      key: `item.imageMb`,
      fn: function (_ref5) {
        var value = _ref5.value;
        return [_c('image-popup', _vm._b({
          attrs: {
            "src": value === null || value === void 0 ? void 0 : value.url
          }
        }, 'image-popup', {
          attrs_avatar: _vm.attrs_avatar
        }, false))];
      }
    }, {
      key: `item.display.enabled`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('v-switch', _vm._b({
          on: {
            "change": function (enabled) {
              return _vm.update({
                _id: item._id,
                display: Object.assign({}, item.display, {
                  enabled
                })
              });
            }
          },
          model: {
            value: item.display.enabled,
            callback: function ($$v) {
              _vm.$set(item.display, "enabled", $$v);
            },
            expression: "item.display.enabled"
          }
        }, 'v-switch', Object.assign({}, _vm.attrs_switch, {
          loading: _vm.loading
        }), false))];
      }
    }, {
      key: `item.display.hasPeriod`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_c('v-switch', _vm._b({
          on: {
            "change": function (hasPeriod) {
              return _vm.update({
                _id: item._id,
                display: Object.assign({}, item.display, {
                  hasPeriod
                })
              });
            }
          },
          model: {
            value: item.display.hasPeriod,
            callback: function ($$v) {
              _vm.$set(item.display, "hasPeriod", $$v);
            },
            expression: "item.display.hasPeriod"
          }
        }, 'v-switch', Object.assign({}, _vm.attrs_switch, {
          loading: _vm.loading
        }), false))];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_c('band-banner-form', {
          attrs: {
            "value": item
          },
          on: {
            "input": _vm.updateItem
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref9) {
              var attrs = _ref9.attrs,
                on = _ref9.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "small": "",
                  "text": "",
                  "icon": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-pencil")])], 1)];
            }
          }], null, true)
        }), _c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-delete")])], 1)];
      }
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false)), _c('v-pagination', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }